<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />
    <v-form ref="formRegistro" v-model="valid" lazy-validation @submit.prevent="handleSubmit()">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="registro.nombre"
            outlined
            v-bind="$attrs"
            v-on="$listeners"
            label="Nombre(s) "
            dense
            type="text"
            :rules="[rules.required]"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="registro.apellidos"
            outlined
            v-bind="$attrs"
            v-on="$listeners"
            label="Apellidos "
            dense
            type="text"
            :rules="[rules.required]"
          />
        </v-col>

        <v-col cols="12" md="12" class="mt-n5">
          <v-text-field
            v-model="registro.correo"
            outlined
            v-bind="$attrs"
            v-on="$listeners"
            label="Correo Electrónico"
            dense
            :rules="[rules.required, rules.email]"
          />
        </v-col>

      </v-row>
      <v-divider></v-divider>
      <p>
        Asegúrese de tener acceso al correo electrónico que está registrando, ya que a través de este recibirá notificaciones.
      </p>

      <v-alert
        v-if="validation_errors.length"
        outlined
        type="error"
        prominent
        border="right"
      >
        <div align="left" class="text-uppercase font-weight-bold">
         Error al tramitar solicitud de aval académico
        </div><br>
        <div align="left" class="font-weight-medium" v-for="(error, key) in this.validation_errors" :key="'validation_'+key">
          -{{ error}}.
        </div>
      </v-alert>

      <base-btn
        :color="!theme.isDark ? 'accent' : 'white'"
        outlined
        :disabled="!disabledSubmitButton" :loading="loading"
        type="submit"
      >
        REGISTRAR
      </base-btn>
    </v-form>


  </div>
</template>

<script>
  const axios = require('axios').default;
  //import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'BaseRegistroAval',
    //components: { VueRecaptcha },


    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: '! INICIE SU SOLICITUD DE AVAL ACADÉMICO !',
      },
    },
    data: () => ({
      //sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      sitekeyV3: process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY,

      path_aviso_privacidad:process.env.VUE_APP_BASE_URL +'/avisoprivacidad/aviso_privacidad_compac.pdf',
      validation_errors:[], //errorores de validacion del backend
      conback:process.env.VUE_APP_BACK_URL_REGISTRA_SOLICITUD_AVAL,
      acepta_politica:true,
      valid: true,
      loading: false,
      disabledSubmitButton: true,

      registro:{
        nombre:'',
        apellidos:'',
        email:''

      },
      rules: {
        required: value => !!value && value.toString().trim() !== '' || 'Este campo es obligatorio',
        email: v =>  {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(v) || 'E-mail invalido.'
        },
      },
    }),
    mounted() {

    },

    methods:{
      handleSubmit() {
        // Validar formulario
        this.disabledSubmitButton = false
        this.loading = true
        const formValid = this.$refs.formRegistro.validate();

        if (!formValid) {
          console.log('Formulario inválido');
          this.loading = false
          this.disabledSubmitButton = true
          return;
        }

        // Generar el token reCAPTCHA v3
        if (!window.grecaptcha) {
          console.error('reCAPTCHA no está cargado');
          this.loading = false
          this.disabledSubmitButton = true

          return;
        }

        grecaptcha.ready(() => {
          grecaptcha.execute(this.sitekeyV3, { action: 'registroaval' }).then((token) => {
            // Enviar los datos junto con el token
            this.registrar(token);
          });
        });
      },

      /*onVerify: function (response) {
        this.verifytoken = response
      },
      onExpired: function () {
        console.log('Expired')
        this.verifytoken = ''
        this.$refs.recaptcha.reset();
      },*/

      async registrar(token) {
        //this.loading = true;
        this.validation_errors = [];

        try {
          const response = await axios.post(this.conback+'/registra-solicitud-aval', {
            nombre: this.registro.nombre,
            correo: this.registro.correo,
            apellidos:this.registro.apellidos,
            recaptcha_token: token,
          });

          // Manejar respuesta exitosa
          this.$swal({
            icon: 'success',
            title: '¡ Listo !',
            text: 'En unos momentos recibirás en tu correo electrónico las intrucciones para continuar con tu ' +
              'solicitud de aval académico  !',
            footer: '<div style="color: red; font-weight: bold">Por favor mantente atento a tu bandeja de entrada (y no olvides revisar la carpeta de spam o promociones)</div>',
            confirmButtonText: "Aceptar"
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              location.reload();
            }
          })


        } catch (error) {

          this.disabledSubmitButton = true
          this.loading = false

          if (error.response && error.response.data && error.response.data.errors) {
            this.validation_errors = Object.values(error.response.data.errors).flat();

          } else {
            //aqui entra cuando algo no coincide cona recaptcha
            //o mientras no traigar array de error el response entrara a aqui
            this.validation_errors = ['Ocurrió un error al registrar la solicitud. Verifique los datos y Reintente nuevamente'];
          }
        } finally {
          this.loading = false;
          this.disabledSubmitButton = true

        }
      },


      registrar2(token) {
        console.log("en registrar ", token)
        this.validation_errors = [];
        var that = this
        if (this.$refs.formRegistro.validate()) {
          if (!this.verifytoken) {
            this.$swal({ icon: 'warning', title: 'Seleccione la casilla No soy un robot' })
            return false;
          }
          this.loading = true
          //alert("hello");
          this.registro.verifytoken = this.verifytoken

          axios.post(this.conback+'/registra-solicitud-aval', this.registro)
            .then(function (response) {
             // that.$refs.formRegistro.reset()
              //that.$refs.formRegistro.resetValidation();
              that.$nextTick(() => {
                that.$refs.formRegistro.reset();
                that.$refs.formRegistro.resetValidation();
              });

              console.log(response.data);

              that.loading = false
              that.$swal({
                icon: 'success',
                title: '¡ Listo !',
                text: 'Hemos enviado las intrucciones a tu correo electrónico para continuar con el ' +
                  'proceso de la solicitud de aval académico  !',
                footer: '<div style="color: red; font-weight: bold">Si el correo no aparece en tu buzón de entrada verifica en correo no deseado o spam',
                confirmButtonText: "Aceptar"
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  location.reload();
                }
              })
            })
            .catch(function (error) {
              that.loading = false
              that.$swal({
                icon: 'error',
                title: 'Error',
                text: 'Hubo error al registrar tus datos, por favor reintenta nuevamente',
                confirmButtonText: "Aceptar"
              })
              //console.log("error al guardar el médico",error.response.data)
              that.loading = false;
              //obtenemos los mensajes de error de la validacion del backend que vienen en en un array simple
              if(error.response.data.hasOwnProperty('messages')){
                for(var i=0; i < error.response.data.messages.length; i++){
                  that.validation_errors.push(error.response.data.messages[i])
                }
              }

            });

        }//end validate


      },
    }

  }
</script>
